import { useLoaderData } from "react-router";
import { SampleDataBanner } from "@/components/case/sample-data-banner";
import { TaskTable } from "@/components/inbox/task-table";
import { PageHeader } from "@/components/layout/page-header";
import { EmptyState } from "@/components/ui";
import { useDocumentTitle } from "@/lib/document-title";
import { formatCompactMoney } from "@/lib/format";
import type { InboxTask } from "@/lib/types";
import { listInboxTasks } from "@/services/cases";

export async function inboxLoader(): Promise<InboxTask[]> {
  return listInboxTasks();
}

export function InboxPage() {
  useDocumentTitle("Inbox");
  const tasks = useLoaderData<InboxTask[]>();
  const blocking = tasks.filter((task) => task.urgency === "blocking").length;
  const total = tasks.reduce((sum, task) => sum + task.amount, 0);

  return (
    <>
      <SampleDataBanner />
      <PageHeader
        title="Inbox"
        description={
          blocking > 0
            ? `${tasks.length} cases need you. ${blocking} cannot progress until evidence arrives.`
            : `${tasks.length} cases need you.`
        }
        action={
          <div className="numeric text-right">
            <div className="eyebrow">Requested volume</div>
            <div className="mt-1 text-lg font-semibold">{formatCompactMoney(total)}</div>
          </div>
        }
      />

      <div className="p-6">
        <div className="overflow-hidden rounded-lg border border-line bg-surface">
          {tasks.length === 0 ? (
            <EmptyState title="Nothing waiting" detail="Every case has been actioned." />
          ) : (
            <TaskTable tasks={tasks} />
          )}
        </div>
      </div>
    </>
  );
}
